import React, { useEffect, useState } from "react";
import Api from "../../../Redux/common/api";

function PackageDis() {
  const [PackageList, setPackageList] = useState([]);

  useEffect(() => {
    hendleToGetData();
  }, []);
  const hendleToGetData = async () => {
    const token = await localStorage.getItem("access_token");

    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    const response = await Api.get(`${"/sellerApi/getPackageList/1"}`, config);

    if (response.status === 200) {
      console.log(response.data.data);
      setPackageList(response.data.data?.docs);
    }
  };
  return (
    <div>
      {" "}
      <div className="testcard card-container p-10">
        {PackageList &&
          PackageList?.map((data, i) => {
            return data?.package == 1 ? (
              <div class="card silver">
                <h2>{data?.packageName}</h2>
                <span>{data?.amount}</span>
                <p>Basic features to get you started.</p>
                <ul>
                  <li>Feature 1</li>
                  <li>Feature 2</li>
                  <li>Feature 3</li>
                </ul>
                <button>Select </button>
              </div>
            ) : data?.package == 2 ? (
              <div class="card gold">
                <h2>{data?.packageName}</h2>
                <span>{data?.amount}</span>
                <p>Advanced features for growing users.</p>
                <ul>
                  <li>Feature 1</li>
                  <li>Feature 2</li>
                  <li>Feature 3</li>
                </ul>
                <button>Select </button>
              </div>
            ) : (
              <div class="card diamond">
                <h2>{data?.packageName}</h2>
                <span>{data?.amount}</span>
                <p>All features for the best experience.</p>
                <ul>
                  <li>Feature 1</li>
                  <li>Feature 2</li>
                  <li>Feature 3</li>
                </ul>
                <button>Select </button>
              </div>
            );
          })}
        {/* <div class="card silver">
          <h2>Silver Package</h2>
          <p>Basic features to get you started.</p>
          <ul>
            <li>Feature 1</li>
            <li>Feature 2</li>
            <li>Feature 3</li>
          </ul>
          <button>Select Silver</button>
        </div>

        <div class="card gold">
          <h2>Gold Package</h2>
          <p>Advanced features for growing users.</p>
          <ul>
            <li>Feature 1</li>
            <li>Feature 2</li>
            <li>Feature 3</li>
          </ul>
          <button>Select Gold</button>
        </div>

        <div class="card diamond">
          <h2>Diamond Package</h2>
          <p>All features for the best experience.</p>
          <ul>
            <li>Feature 1</li>
            <li>Feature 2</li>
            <li>Feature 3</li>
          </ul>
          <button>Select Diamond</button>
        </div> */}
      </div>
    </div>
  );
}

export default PackageDis;
